<template>
  <div>
    <slot :count="count" :data="localData"></slot>
  </div>
</template>

<script>
import replicator from "../admin/mixins/replicator";

export default {
  mixins: [replicator]
};
</script>
